"use strict";
// Blocks: owner-editable sections, blocks and app embeds over the app's own
// React code (contract: @dunea/plugin-sdk primitives/blocks).
//
//   frontend/src/blocks/local/<name>.tsx + .block.json   the AI builds sections as blocks
//   frontend/src/blocks/theme/…                          the applied theme's sections (apply_theme)
//   frontend/src/blocks/<listing-slug>/…                 marketplace plugins (studio writes them on install)
//   frontend/src/content/sections.json                   pages → ordered sections + settings
//   frontend/src/dunea/blocks.tsx                        runtime: <SectionGroup id>, <BlockEmbeds/>
//
// Studio's host half (modules/plugins/blocks) serves the owner's Sections
// panel and keeps marketplace blocks in sync with active installs.
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLOCKS_PLUGIN = void 0;
exports.BLOCKS_PLUGIN = {
    id: 'blocks',
    version: '1.0.0',
    kind: 'capability',
    trust: 'first-party',
    title: 'Sections',
    description: 'Sections the owner can add, reorder, hide and edit without code; themes and plugins can ship their own.',
    icon: 'i-ph:stack',
    surfaces: ['web-app'],
    agentCard: 'Blocks: build page sections as blocks (src/blocks/local/<name>.tsx + .block.json, placed in src/content/sections.json, rendered by <SectionGroup id>) so the owner can edit them in the Sections panel (skills/blocks.md).',
    // Marketplace installs carrying blocks are written to / removed from the app.
    subscribes: ['marketplace.install.activated', 'marketplace.install.removed'],
    permissions: ['sandbox:files'],
    targets: {
        'web-app': {
            skills: ['blocks'],
            lockedPaths: ['frontend/src/dunea/blocks.tsx'],
            // blocks.tsx re-exports the custom data hooks (data.tsx, which uses payments' fetch runtime).
            uses: ['frontend/src/dunea/data.tsx', 'frontend/src/dunea/payments.tsx'],
            detect: ['<SectionGroup'],
            budgetGzipKb: 6,
        },
    },
};
